import React, { useEffect, useState } from "react";
import { ZeusButton, ZeusTypography } from "zeus-front-design-system";
import * as styles from "./RegistrationConfirmation.module.scss";
import AttendanceShell from "../AttendanceShell/AttendanceShell";
import Correct from "../../assets/gifs/correct.gif";
import formatName from "../../utils/formatName";

type RegistrationConfirmationProps = {
  title?: string;
  successText?: string;
  employeeName: string;
  onExit: () => void;
  exitLabel?: string;
  imageUrl?: string;
  autoCloseIn?: number;
  exitPrefix?: string;
};

export default function RegistrationConfirmation({
  title = "Estupendo, iniciemos el día",
  successText = "Registro realizado con éxito",
  employeeName,
  onExit,
  exitLabel = "Salir",
  autoCloseIn = 16,
  exitPrefix = "Salir",
}: RegistrationConfirmationProps) {
  const [secondsLeft, setSecondsLeft] = useState<number>(autoCloseIn ?? 16);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onExit();
      return;
    }
    const t = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [secondsLeft, onExit]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onExit();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onExit]);

  const exitText =
    typeof autoCloseIn === "number" && autoCloseIn > 0
      ? `${exitPrefix} (${secondsLeft})`
      : exitLabel;

  const header = (
    <>
      <ZeusTypography
        component="h1"
        type="Headline"
        style="bold"
        size="medium"
        color="#262626"
        className={styles.greeting}
      >
        {title}
      </ZeusTypography>
      <ZeusTypography
        component="h1"
        type="Headline"
        style="bold"
        size="medium"
        color="#262626"
        className={styles.greetingEmployeeName}
      >
        {formatName(employeeName)}🔥
      </ZeusTypography>
    </>
  );

  return (
    <AttendanceShell
      header={header}
      subtitle={successText || "Realiza el registro de hoy."}
      timeFormat="12h"
      dividerText="Registro completado"
    >
      <img src={Correct} className={styles.imageCorrect} />
      <ZeusButton
        textContent={exitText}
        onClick={onExit}
        width={"auto"}
        className={styles.exitBtn}
        withArrow={false}
      />
    </AttendanceShell>
  );
}
